import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSaveShiftTutorialMutation, useShiftTutorial } from 'queries/shift'

import { Loading, toast } from '@workwhile/ui'
import { TutorialCategory } from 'api/shift/typings'
import { Page } from 'pages/layout'
import { HeaderBar } from 'pages/layout/HeaderBar'
import { useCompatTutorial } from 'hooks/useCompatTutorial'
import { EditorProvider, EditorView } from 'components/Tutorials'

export function ShiftInstructionEditor() {
  const navigate = useNavigate()
  const params = useParams<{ shiftId: string; idOrCategory: string }>()
  const shiftId = Number(params.shiftId)
  const idOrCategory = params.idOrCategory as string
  const tutorialId = useMemo(() => {
    if (!isNaN(Number(idOrCategory))) {
      return Number(idOrCategory)
    }
  }, [idOrCategory])
  const { data, isLoading } = useShiftTutorial(shiftId, tutorialId)
  const tutorial = data?.tutorial
  const location = data?.location
  const position = data?.position
  const compatTutorial = useCompatTutorial(tutorial)
  const category = useMemo(() => {
    if (tutorial) {
      return tutorial.category
    }
    return idOrCategory
  }, [idOrCategory, tutorial])
  const {
    mutate: saveTutorial,
    isPending: isSaving,
    error,
  } = useSaveShiftTutorialMutation({
    shiftId,
    tutorialId,
    category: category as TutorialCategory,
    onSuccess(tutorialId) {
      toast.success('Instruction saved successfully')
      if (tutorialId) {
        // update route
        navigate(`/shift/${shiftId}/instruction/${tutorialId}`, {
          replace: true,
        })
      }
    },
  })

  if (isLoading) {
    return <Loading />
  }

  return (
    <Page>
      <HeaderBar />
      <EditorProvider
        location={location}
        position={position}
        category={category as TutorialCategory}
        tutorialId={tutorialId}
        tutorial={compatTutorial}
        isSaving={isSaving}
        error={error}
        showOptions
        showNotifyWorkers
        title="How would you like to save this instruction?"
        saveTutorial={saveTutorial}
      >
        <EditorView />
      </EditorProvider>
    </Page>
  )
}
